import { useFormContext } from "react-hook-form";
import { MAX_HOURLY_PRICE, TEACHER_MIN_HOURLY_PRICE } from "@academy-context/write/domain/constants/shared";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { Input } from "@shared-kernel/primary/shared/shadcn/ui/input";
import type { TeacherOnboardingFormInputs } from "../form-validation/full-form.schema";
import { IbanInput } from "@shared-kernel/primary/shared/iban-input/iban-input";

export const BillingStep = () => {
  const { control } = useFormContext<TeacherOnboardingFormInputs>();

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="defaultPrice"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Tarif horaire standard (€/heure)</FormLabel>
            <FormControl>
              <Input type="number" step="1" min={TEACHER_MIN_HOURLY_PRICE} max={MAX_HOURLY_PRICE} {...field} value={field.value ?? ""} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="iban"
        render={({ field }) => (
          <FormItem>
            <FormLabel>IBAN (zone Euro)</FormLabel>
            <FormControl>
              <IbanInput placeholder="Exemple : FR76 4061 8803 0000 0408 3645 139" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
